module.exports = __webpack_public_path__ + "img/students-2.ac38c0da.jpg";